import { ActivityComponentType } from '@stackflow/react'
import dynamic from 'next/dynamic'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import LoadingSpinner from '../../common/LoadingSpinner'
import WebviewStackContainer from '../common/WebviewStackContainer'

const ConversationCompleteBody = dynamic(() => import('../../new-portal/conversational-ai/CompleteBody'), {
  loading: () => (
    <div className="flex h-screen w-screen items-center justify-center">
      <LoadingSpinner lg show primary />
    </div>
  ),
})

const ConversationCompleteActivity: ActivityComponentType = () => {
  const router = useAppRouter()
  const threadId = router.query?.threadId

  return (
    <WebviewStackContainer height="0px" border={false}>
      <ConversationCompleteBody threadId={threadId} />
    </WebviewStackContainer>
  )
}

export default ConversationCompleteActivity
